import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["toggleable"];
  static values = { open: Boolean };

  toggle() { this.openValue = !this.openValue; }
  show() { this.openValue = true; }
  hide() { this.openValue = false; }

  openValueChanged() {
    this.toggleableTargets.forEach((el) => el.classList.toggle("hidden", !this.openValue));
  }
}
